/* eslint-disable */
import React from "react";
import styled from "@emotion/styled";
import linzhi from "@/assets/images/linzhitaohua2022/linzh.jpg";
import styles from './style.module.scss';


function Homemobile() {
    return (
        <HomeContainermobile>
            <img className={styles.img_src} src={linzhi} />
        </HomeContainermobile>
    );
}

const HomeContainermobile = styled.div`
    width: 100%;
    background-color: #fafcff;
    position: relative;
`;

export default Homemobile;
